import { createStore } from 'vuex';
import api from '@/api/index';

// 数据预处理工具函数
const processData = (retlist) => {
  return retlist.map(item => {
    const processed = { ...item };
    
    // 1. 确保所有数值字段转换为数字
    Object.keys(processed).forEach(key => {
      if (key !== 'time' && key !== 'id') {
        processed[key] = processed[key] !== null ? Number(processed[key]) : 0;
      }
    });

    // 2. 核心修复：解析后端特殊的 "2605141500" 时间格式
    let t = processed.time;
    if (typeof t === 'string' && t.length === 10) {
      let year = 2000 + parseInt(t.substring(0, 2));
      let month = parseInt(t.substring(2, 4)) - 1; // JS 月份从 0 开始
      let day = parseInt(t.substring(4, 6));
      let hour = parseInt(t.substring(6, 8));
      let minute = parseInt(t.substring(8, 10));
      processed.time = new Date(year, month, day, hour, minute).getTime();
    } else {
      processed.time = new Date(t).getTime();
    }

    return processed;
  });
};

const store = createStore({
  state: () => ({
    wnData: [],  // 🌟 彻底更名：万宁数据
    wfdData: [], // 🌟 彻底更名：另一组数据
    pollingTimers: [] 
  }),
  mutations: {
    SET_WN_DATA(state, data) {
      state.wnData = data;
    },
    SET_WFD_DATA(state, data) {
      state.wfdData = data;
    },
    ADD_POLLING_TIMER(state, timer) {
      state.pollingTimers.push(timer);
    },
    CLEAR_POLLING_TIMERS(state) {
      state.pollingTimers.forEach(timer => clearInterval(timer));
      state.pollingTimers = [];
    }
  },
  actions: {
    // 启动双数据库轮询
    startPolling({ commit, dispatch }) {
      // 轮询万宁(wn)数据
      const wnTimer = setInterval(() => dispatch('fetchWnData'), 60000);
      commit('ADD_POLLING_TIMER', wnTimer);
      
      // 轮询(wfd)数据
      const wfdTimer = setInterval(() => dispatch('fetchWfdData'), 60000);
      commit('ADD_POLLING_TIMER', wfdTimer);
      
      // 首次立即执行
      dispatch('fetchWnData');
      dispatch('fetchWfdData');
    },
    // 停止轮询
    stopPolling({ commit }) {
      commit('CLEAR_POLLING_TIMERS');
    },
    
    // 获取万宁(wn)真实数据
    async fetchWnData({ commit }) {
      try {
        const params = new URLSearchParams({ action: 'wn_Data_list_customer' });
        const res = await api.getData(params);
        if (res.data?.ret === 0) {
          commit('SET_WN_DATA', processData(res.data.retlist));
        }
      } catch (err) {
        console.error('万宁(wn)数据获取失败:', err);
      }
    },

    // 获取(wfd)真实数据
    async fetchWfdData({ commit }) {
      try {
        const params = new URLSearchParams({ action: 'wfd_Data_list_customer' });
        const res = await api.getData(params);
        if (res.data?.ret === 0) {
          commit('SET_WFD_DATA', processData(res.data.retlist));
        }
      } catch (err) {
        console.error('瓦房店(WFD)数据获取失败:', err);
      }
    }
  },

  getters: {
    chartData: (state) => (field) => {
      return {
        // 🌟 键名也同步修改为 wn 和 wfd
        wn: state.wnData.map(d => [d.time, d[field]]),
        wfd: state.wfdData.map(d => [d.time, d[field]])
      };
    }
  }
});

export default store;


// import { createStore } from 'vuex';
// import api from '@/api/index';

// // 数据预处理工具函数
// const processData = (retlist) => {
//   return retlist
//     .map(item => {
//       const processed = { ...item };
//       // 确保所有数值字段转换为数字
//       Object.keys(processed).forEach(key => {
//         if (key !== 'time') {
//           processed[key] = processed[key] !== null ? Number(processed[key]) : 0;
//         }
//       });
//       // 将时间字符串转换为时间戳（毫秒）
//       processed.time = new Date(processed.time).getTime();
//       return processed;
//     })
//     // 按时间升序排序（ECharts 要求时间轴数据有序）
//     .sort((a, b) => a.time - b.time);
// };

// const store = createStore({
//   state: () => ({
//     bhData: [], // 数据库1的轮询数据
//     hnData: [], // 数据库2的轮询数据
//     pollingTimers: [] // 轮询定时器数组
//   }),
//   mutations: {
//     SET_BH_DATA(state, data) {
//       state.bhData = data;
//     },
//     SET_HN_DATA(state, data) {
//       state.hnData = data;
//     },
//     ADD_POLLING_TIMER(state, timer) {
//       state.pollingTimers.push(timer);
//     },
//     CLEAR_POLLING_TIMERS(state) {
//       state.pollingTimers.forEach(timer => clearInterval(timer));
//       state.pollingTimers = [];
//     }
//   },
//   actions: {
//     // 启动双数据库轮询
//     startPolling({ commit, dispatch }) {
//       // 轮询数据库1
//       const bhTimer = setInterval(() => dispatch('fetchBhData'), 50000);
//       commit('ADD_POLLING_TIMER', bhTimer);
//       // 轮询数据库2
//       const hnTimer = setInterval(() => dispatch('fetchHnData'), 50000);
//       commit('ADD_POLLING_TIMER', hnTimer);
//       // 首次立即执行
//       dispatch('fetchBhData');
//       dispatch('fetchHnData');
//     },
//     stopPolling({ commit }) {
//     commit('CLEAR_POLLING_TIMERS');
//      },
//     // 获取数据库1数据
//     async fetchBhData({ commit }) {
//       try {
//         const params = new URLSearchParams({ action: 'bh_Data_list_customer' });
//         const res = await api.getData(params);
//         if (res.data?.ret === 0) {
//           commit('SET_BH_DATA', processData(res.data.retlist));
//         }
//       } catch (err) {
//         console.error('BH数据获取失败:', err);
//       }
//     },
//     // 获取数据库2数据
//     async fetchHnData({ commit }) {
//       try {
//         const params = new URLSearchParams({ action: 'hn_Data_list_customer' });
//         const res = await api.getData(params);
//         if (res.data?.ret === 0) {
//           commit('SET_HN_DATA', processData(res.data.retlist));
//         }
//       } catch (err) {
//         console.error('HN数据获取失败:', err);
//       }
//     },   
//   },

//   getters: {
//     chartData: (state) => (field) => {
//       return {
//         // 确保数据格式为 [时间戳, 值]
//         bh: state.bhData.map(d => [new Date(d.time).getTime(), d[field]]),
//         hn: state.hnData.map(d => [new Date(d.time).getTime(), d[field]])
//       };
//     }
//   }
// });

// export default store;
